// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const TitleOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="TitleOffIcon" ref={forwardedRef} {...props}>
      <path d="M15.93 4.62 17 3.55 15.95 2.5 3 15.459l1.05 1.05 6.25-6.255V17.5h1.485V8.768l2.66-2.661h2.534V4.62z" />
      <path d="M5.1 4.62h6.506L10.12 6.108H5.1z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const TitleOffIcon = /* @__PURE__ */ Object.assign(
  TitleOffIconComponent,
  { displayName: 'TitleOffIcon' },
);
